<div class="flex min-h-screen flex-col items-center justify-center">
  <p class="mb-4 text-5xl font-bold">Error {{ statusCode }}</p>
  <p class="mb-6 text-xl">{{ message }}</p>
</div>
